"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { FC } from "react";

interface FloatThemeButtonProps {}

export const FloatThemeButton: FC<FloatThemeButtonProps> = ({}) => {
  const { theme, setTheme } = useTheme();

  return (
    <button
      className="border-px bg-on-background animate-in fade-in-0 slide-in-from-bottom-4 z-99! fixed bottom-[30px]
        right-[35px] flex h-[60px] w-[60px] items-center justify-center rounded-md border p-0 duration-500
        ease-in-out"
      onClick={() => {
        if (theme === "dark") {
          setTheme("light");
        } else {
          setTheme("dark");
        }
      }}
    >
      <div className="text-foreground cursor-pointer">
        <Sun className="hidden h-4 w-4 dark:block" />
        <Moon className="h-4 w-4 dark:hidden" />
      </div>
    </button>
  );
};
